"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var loadingScriptWindow = window;
loadingScriptWindow.loadingScripts = loadingScriptWindow.loadingScripts || [];
function createScript(src) {
    var scriptElement = document.createElement('script');
    scriptElement.src = src;
    scriptElement.async = false;
    scriptElement.onload = function (e) {
        var index = loadingScriptWindow.loadingScripts.indexOf(src);
        if (index > -1) {
            loadingScriptWindow.loadingScripts = loadingScriptWindow.loadingScripts.splice(index, 1);
        }
    };
    loadingScriptWindow.loadingScripts.push(src);
    return scriptElement;
}
exports.default = createScript;
